import BASEURLPROJETOS from "../api/projetos";
import { payloadCadastrar5w2h, Atualizar5w2h, filtroPayload } from "../../interfaces/5w2h"
import { payloadCadastrarDesafio, payloadAtualizarDesafio, payloadCadastrarMatriz, payloadAtualizarMatriz, paramsFiltroPlanoAcao, payloadCadastrarPlanoAcao, payloadAtualizarPlanoAcao } from "../../interfaces/desafios"

export function cadastrarDesafio(payload: payloadCadastrarDesafio) {
  return BASEURLPROJETOS.post("/desafios", payload);
}

export function atualizarDesafio(idDesafio: string, payload: payloadAtualizarDesafio) {
  return BASEURLPROJETOS.patch(`/desafios/${idDesafio}`, payload);
}

export function buscarDesafio(idProjeto: string) {
  return BASEURLPROJETOS.get(`/desafios?idProjeto=${idProjeto}`);
}

export function filtrarDesafio(filtroPayload: filtroPayload) {
  return BASEURLPROJETOS.get(`/desafios?idProjeto=${filtroPayload.idProjeto}&idResponsavel=${filtroPayload.idResponsavel}&titulo=${filtroPayload.titulo}&situacao=${filtroPayload.situacao}`);
}

export function criarMatrizGut(payload: payloadCadastrarMatriz) {
  return BASEURLPROJETOS.post("/matrizGut", payload);
}

export function atualizarMatrizGut(idMatriz: string, payload: payloadAtualizarMatriz) {
  return BASEURLPROJETOS.patch(`/matrizGut/${idMatriz}`, payload);
}

export function cadastrar5w2h(payload: payloadCadastrar5w2h) {
  return BASEURLPROJETOS.post("/5w2h", payload);
}

export function atualizar5w2h(id5w2h: string, payload: Atualizar5w2h) {
  return BASEURLPROJETOS.patch(`/5w2h/${id5w2h}`, payload);
}

export function buscarPlanoAcao(params: paramsFiltroPlanoAcao) {
  return BASEURLPROJETOS.get(`/planoAcao?idProjeto=${params.idProjeto}&titulo=${params.titulo}&idResponsavel=${params.idResponsavel}&situacao=${params.situacao}`);
}

export function cadastrarPlanoAcao(payload: payloadCadastrarPlanoAcao) {
  return BASEURLPROJETOS.post(`/planoAcao`, payload);
}

export function atualizarPlanoAcao(idPlanoAcao: string, payload: payloadAtualizarPlanoAcao) {
  return BASEURLPROJETOS.patch(`/planoAcao/${idPlanoAcao}`, payload);
}